import React, { useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { Lock, Menu, FilterAlt } from "@mui/icons-material";

import { useValue } from "../context/ContextProvider";
import UserIcons from "./user/UserIcons";
import Sidebar from "./sidebar/Sidebar";

import { createTheme } from '@mui/material/styles';

const NavBar = () => {
  const {
    state: { currentUser },
    dispatch,
  } = useValue();


  const [isOpen, setIsOpen] = useState(false);

  const theme = createTheme({
    palette: {
      ochre: {
        main: '#c8494d',  /*this changes the main navbar color '#1292c9'*/
        light: '#E9DB5D',
        dark: '#A29415',
        contrastText: '#f7f7f7',
      },
    },
  });

  return (
    <>
      <AppBar theme={theme} color="ochre">
        <Container maxWidth="lg">
          <Toolbar disableGutters>
            <Box sx={{ mr: 1 }}>
              <IconButton
                size="large"
                color="#FFFFFF"
                onClick={() => setIsOpen(true)}
              >
                <FilterAlt />
              </IconButton>
            </Box>
            <Typography
              variant="h6"
              component="h1"
              color="#FFFFFF"
              noWrap
              sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
            >
              The Cycling Road Map
            </Typography>
            <Typography
              variant="h6"
              component="h1"
              color="#FFFFFF"
              noWrap
              sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
            >
              RM
            </Typography>
            {/* {!currentUser ? (
              <Button
                color="inherit"
                startIcon={<Lock />}
                onClick={() => dispatch({ type: 'OPEN_LOGIN' })}
              >
                Login
              </Button>
            ) : (
              <UserIcons />
            )} */}
          </Toolbar>
        </Container>
      </AppBar>
      <Toolbar />
      <Sidebar {...{ isOpen, setIsOpen }} />
    </>
  );
};

export default NavBar;
